module.exports = __webpack_public_path__ + "img/arh_2.63165a9e.png";